module.exports = __webpack_public_path__ + "img/product-preview-86.87c4b67.png";